import createApiClient from "./api";

const api = createApiClient("/daily-reports");

export async function fetchDailyReportByDate(projectId, date) {
  const formattedDate = date.format().split("T")[0];
  const response = await api.get("/from-date", {
    params: {
      project_id: projectId,
      date: formattedDate,
    },
    headers: {},
  });
  return response.data;
}

export async function updateDailyReport({ dailyReport, dailyReportId }) {
  const response = await api.put(`/${dailyReportId}`, dailyReport, {
    headers: {},
  });
  return response.data;
}

export async function copyDailyReport({ projectId, copyFromDate, copyToDate }) {
  const formattedCopyFromDate = copyFromDate.format().split("T")[0];
  const formattedCopyToDate = copyToDate.format().split("T")[0];
  const response = await api.post(
    "/copy",
    {},
    {
      headers: {},
      params: {
        project_id: projectId,
        copy_from_date: formattedCopyFromDate,
        copy_to_date: formattedCopyToDate,
      },
    }
  );
  return response.data;
}

export async function generateDailyReportPdf({ dailyReportId, projectId }) {
  const response = await api.post(`/${dailyReportId}/generate-pdf`, {}, {
    headers: {},
    params: {
      project_id: projectId,
    },
  });
  return response.data;
}

export async function fetchDailyReportsByDateRange({
  projectId,
  startDate,
  endDate,
}) {
  const formattedStart = startDate.format
    ? startDate.format().split("T")[0]
    : startDate;
  const formattedEnd = endDate.format
    ? endDate.format().split("T")[0]
    : endDate;
  const response = await api.get(`/by-date-range`, {
    headers: {},
    params: {
      project_id: projectId,
      start_date: formattedStart,
      end_date: formattedEnd,
    },
  });
  return response.data;
}

export async function generateDailyReportsPdfByDateRange({
  projectId,
  startDate,
  endDate,
}) {
  const formattedStart = startDate.format
    ? startDate.format().split("T")[0]
    : startDate;
  const formattedEnd = endDate.format
    ? endDate.format().split("T")[0]
    : endDate;
  const response = await api.post(
    `/generate-pdf-range`,
    {},
    {
      headers: {},
      params: {
        project_id: projectId,
        start_date: formattedStart,
        end_date: formattedEnd,
      },
    }
  );
  return response.data;
}

export async function fetchDailyReportPhotos({ projectId, date, page = 1, pageSize = 8 }) {
  const params = { project_id: projectId, skip: (page - 1) * pageSize, limit: pageSize };
  if (date) {
    const formatted = date.format ? date.format().split("T")[0] : date;
    params.date = formatted;
  }
  const response = await api.get(`/photos`, { params, headers: {} });
  return response.data;
}

export async function notifyProjectUsersAboutDailyReport({
  projectId,
  startDate,
  endDate,
  userIds = null,
  note = null,
}) {
  const formattedStart = startDate.format
    ? startDate.format().split("T")[0]
    : startDate;
  const formattedEnd = endDate.format
    ? endDate.format().split("T")[0]
    : endDate;
  const requestBody = {
    project_id: projectId,
    start_date: formattedStart,
    end_date: formattedEnd,
  };
  if (userIds && Array.isArray(userIds) && userIds.length > 0) {
    requestBody.user_ids = userIds;
  }
  if (note) {
    requestBody.note = note;
  }
  const response = await api.post(`/notify`, requestBody, {
    headers: {},
  });
  return response.data;
}
